module.exports = __webpack_public_path__ + "static/media/tv-alt.a492b3fa.svg";